/**
 * Wettelijke vermeldingen — JURIDISCH GEVALIDEERDE TEKST. Niet herformuleren.
 *
 * Traduction du français, phrase par phrase : transport, pas rédaction.
 * La structure, l'ordre des sections et les jetons {{...}} sont ceux de
 * `mentions-legales.fr.js`. En cas de divergence, c'est la version
 * française qui prévaut — la clause en tête du document le dit.
 *
 * Références belges : les noms officiels néerlandais sont utilisés là où
 * ils existent (« Consumentenombudsdienst »). Les noms propres, les URL
 * et les adresses email ne se traduisent pas.
 */
const MENTIONS_LEGALES_NL = String.raw`
# Wettelijke vermeldingen

**archer.law**
Laatst bijgewerkt: {{DATE_MISE_EN_LIGNE}}

*Dit document is beschikbaar in het Frans, het Nederlands en het Engels. In geval van tegenstrijdigheid tussen de taalversies heeft de Franse versie voorrang.*

## Uitgever van de site

De site archer.law wordt uitgegeven door:

**RND CONCIERGE SERVICES - FZCO**
Vennootschap in een vrije zone (Freezone Company) naar Emiraats recht
Handelsvergunning nr. 63620 · Dubai Integrated Economic Zones Authority (IFZA)
Maatschappelijke zetel: DSO-IFZA, IFZA Properties, Dubai Silicon Oasis, Dubai, Verenigde Arabische Emiraten

**Verantwoordelijke uitgever**: Romain Debecq, manager

**Contact en persoonsgegevens**: bonjour@archer.law

## Hosting

De applicatie en de gegevens worden gehost door:

**Railway Corporation**
548 Market St, San Francisco, CA 94104, Verenigde Staten
railway.com

## Aard van de dienst

Archer is een technologisch platform voor juridische informatie en juridische bijstand. **Archer is geen advocatenkantoor** en is niet ingeschreven bij een balie; **Archer is geen verzekeringsmaatschappij**. De door de Dienst gegenereerde inhoud vormt juridische informatie en vervangt de raadpleging van een advocaat niet. De advocaten die via de marktplaats toegankelijk zijn, zijn onafhankelijke beroepsbeoefenaars, ingeschreven bij een Belgische balie, die rechtstreeks met de klant contracteren.

## Intellectuele eigendom

Het geheel van de elementen van de site (structuur, teksten, grafische elementen, logo's, de mascotte Archer, software) is beschermd door het auteursrecht en het merkenrecht. Elke gehele of gedeeltelijke reproductie of weergave zonder voorafgaande schriftelijke toestemming is verboden, met uitzondering van strikt privégebruik en van de voor de klant in het kader van de Dienst gegenereerde documenten.

## Meldingen

Om onrechtmatige inhoud of onrechtmatig gebruik van de Dienst te melden: bonjour@archer.law. Wij behandelen meldingen met zorgvuldigheid.

## Geschillen en bemiddeling

De site en de diensten worden beheerst door de Algemene voorwaarden, onderworpen aan het Belgisch recht. De consument kan een beroep doen op de Consumentenombudsdienst (mediationconsommateur.be, Koning Albert II-laan 8 bus 1, 1000 Brussel) en op het Europees platform voor onlinegeschillenbeslechting: ec.europa.eu/consumers/odr.
`;

export default MENTIONS_LEGALES_NL;
